import { useMutation, useQueryClient } from 'react-query';
import { handleError } from '../../../../../../../shared/ErrorCatching';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { editedImageQueryKey } from '../../imagePreview/queries/use-query-edited-image';
import { SE360_RECIPIENT } from '../state/utils';

type AddCommentMutationArgs = {
    orderId: number;
    imageId: number;
    user: AuthenticatedUser;
};

export function useAddCommentMutation({ orderId, imageId, user }: AddCommentMutationArgs) {
    let queryClient = useQueryClient();
    let { logger } = useTelemetryContext();

    return useMutation(
        (text: string) => ImageProcessingApi.saveComment(orderId, imageId, text, SE360_RECIPIENT),
        {
            onSuccess: () => queryClient.invalidateQueries([editedImageQueryKey, { orderId }]),
            onError: (error) => {
                logger.logException(error, {
                    origin: 'ImageEditorImageProcessingPage.Mutation.saveComment',
                    userInfo: getUserInfo(user),
                    imageId
                });
                handleError(error);
            }
        }
    );
}
